import React, { useState } from "react";
import Popup from "./Popup";

import { ReactComponent as Seat } from "../../assets/icons/book-seat.svg";
import Wheel from "../../assets/images/wheel.png";
import { useNavigate } from "react-router-dom";
import notify from "../utils/notify";
import { useDispatch, useSelector } from "react-redux";
import { setSeat } from "../../reducer/bookingSlice";
import { IRootState } from "../../reducer/store";

type PropType = {
  onClose: () => void;
};
const SelectSeatPopup = ({ onClose }: PropType) => {
  const bookings = useSelector(
    (state: IRootState) => state.booking.value.booking
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedSeats, setSelectedSeats] = useState<any>([]);
  const totalSeats = 14;
  const takenSeats = [1, 3];
  const totl = Number(bookings.adult) + Number(bookings.children);
  const maxSelection = totl;

  //
  const [seats, setSeats] = useState(Array(totalSeats).fill(false));

  const handleSeatClick = (seatIndex: number) => {
    if (takenSeats.includes(seatIndex)) {
      return; // Ignore clicks on taken seats
    }
    // if (selectedSeats.length === maxSelection) {
    //   alert("Stop");
    //   return; // Ignore clicks on taken seats
    // }

    const updatedSeats = [...seats];
    updatedSeats[seatIndex] = !updatedSeats[seatIndex];
    setSeats(updatedSeats);
    const selectedSeatNumbers = updatedSeats
      .map((isOccupied, index) => (isOccupied ? index + 1 : null))
      .filter((seatNumber) => seatNumber !== null);

    if (updatedSeats[seatIndex] && selectedSeatNumbers.length > maxSelection) {
      notify("error", "maximum selection exceded");
      return; // Ignore selection if maximum seats are already selected
    }

    // setSeats(updatedSeats);
    setSelectedSeats(selectedSeatNumbers);

    console.log(selectedSeats);
  };

  const onProceed = () => {
    dispatch(setSeat(selectedSeats));
    navigate("/passenger-details");
  };

  return (
    <Popup onClose={onClose} title="Select Seat(s)">
      <div className="p-4 flex flex-col items-center justify-center-center">
        <div className="flex items-center text-sm w-full justify-between md:px-10">
          <div className="flex flex-col items-center gap-2">
            <Seat fill="#333333" className="w-10 h-10" />
            <div className="">Booked Seat</div>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Seat fill="#145874" className="w-10 h-10" />
            <div className="">Available Seat</div>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Seat fill="#169559" className="w-10 h-10" />
            <div className="">Selected Seat</div>
          </div>
        </div>
        <div className="border-b my-3 w-full"></div>
        {/*  */}
        <div>
          <div className="">
            <div className="grid grid-cols-4 gap-6  md:px-5 py-5">
              <div className="w-32 h-32 ">
                <img src={Wheel} alt="" className="w-full" />
              </div>
              {/* <div className=""></div> */}
              <div className=""></div>
              {seats.map((isOccupied, index) => (
                <div
                  key={index}
                  className="relative w-fit h-fit"
                  onClick={() => handleSeatClick(index)}
                >
                  <Seat
                    className={`w-12 h-12 md:w-20 md:h-20 fill-[#145874]
                  ${takenSeats.includes(index) ? "fill-[#333333]" : ""}
                  ${selectedSeats.includes(index + 1) ? "fill-[#169559]" : ""}`}
                  />
                  <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center text-white font-semibold">
                    <div className="">{index + 1}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <button
          className="outline-none h-11 flex items-center justify-center text-white my-10 px-8 bg-[#B9000A]"
          onClick={onProceed}
        >
          Proceed
        </button>
      </div>
    </Popup>
  );
};

export default SelectSeatPopup;
